<template>
    <div id="recharge">
        <section class="section1">
            <ul>
                <li>
                    <label>代理商</label>
                    <span>{{ nickName }}</span>
                </li>
                <li>
                    <label>总充值金额</label>
                    <span>{{ account.totalHistoryRmb }} 元</span>
                </li>
                <li>
                    <label>已用金额</label>
                    <span>{{  decrease( account.totalHistoryRmb, account.balanceRmb ) }} 元</span>
                </li>
                <li>
                    <label>剩余金额</label>
                    <span>{{ account.balanceRmb }} 元</span>
                </li>
            </ul>            
        </section>
        <section class="section2">
            <div>
                <input v-model.number="priceRmb" type="text" placeholder="请输入充值金额">                
            </div>
            <div>
                <mt-button type="primary" size="large" @click="toRechargeHandler">立即充值</mt-button>
            </div>
        </section>
    </div>
</template>
<script>
import { wxRequest} from '@/api/agent.js'
export default {
    data(){
        return {
            account: {
                totalHistoryRmb: '',
                balanceRmb: ''
            },
            priceRmb: '',
            nickName: localStorage.getItem('nickName')
        }
    },
    methods: {
        toRechargeHandler(){
            var data = {
                priceRmb: this.priceRmb
            }
            wxRequest('order/investOrder/agent/add', data, 'post').then(res => {
                if(res.data.code == 200){
                    var orderId = res.data.data.id;

                    if (typeof WeixinJSBridge == "undefined"){
                        if( document.addEventListener ){
                            document.addEventListener('WeixinJSBridgeReady', this.onBridgeReady, false);
                        }else if (document.attachEvent){
                            document.attachEvent('WeixinJSBridgeReady', this.onBridgeReady); 
                            document.attachEvent('onWeixinJSBridgeReady', this.onBridgeReady);
                        }
                    }else{
                        this.onBridgeReady(orderId);
                    }                      
                }
            })
        },
        onBridgeReady(orderId){          
            var data = {
                id: orderId
            }
            wxRequest('order/investOrder/payParam', data, 'post').then(res => {
                if(res.data.code == 200){
                    let _this = this;
                    var param = res.data.data.param;
                    WeixinJSBridge.invoke(
                        'getBrandWCPayRequest', {
                            "appId": param.appId,                 //公众号名称，由商户传入     
                            "timeStamp": param.timeStamp,         //时间戳，自1970年以来的秒数     
                            "nonceStr": param.nonceStr,           //随机串     
                            "package": param.package,     
                            "signType": param.signType,           //微信签名方式     
                            "paySign": param.paySign              //微信签名 
                        },
                        function(res){
                            if(res.err_msg == "get_brand_wcpay_request:ok" ){
                                _this.$router.push('/agent/rechargeRecord')
                            } 
                        }
                    );              
                }
            })
        }
    },
    created(){
        wxRequest('agent/account/list', {}, 'post').then(res => {
            if(res.data.code == 200){
                var accountList = res.data.data.resultList;
                accountList.forEach(item => {
                    if(item.type == 20){
                        this.account = item;
                    }
                });
            }
        })
    }
}
</script>
<style lang="less" scoped>
#recharge {
    height: 100%;
    padding-top: 10px;
    background: #f2f2f2;
    section {
        margin: 0 10px 10px;
        padding: 10px;
        background: #fff;
        border-radius: 10px;
        ul li {
            height: 40px;
            line-height: 40px;
            border-bottom: 1px solid #eaeaea;
            display: flex;
            justify-content: space-between;
            &:last-child {
                border-bottom: none;
            }
            span {
                color: #FF9C3C;
            }
        }
    }
    .section2 {
        div {
            margin: 10px 0 30px;
            padding: 0 10px;
            input[type=text] {
                border: 1px solid #e0e0e0;
                outline: none;
                padding: 8px;
                line-height: 1.6em;
                width: 100%;
                box-sizing: border-box;
            }               
        }
     
    }

}
</style>
